<div class="wizard-buttons">
  <button mat-raised-button class="button--secondary button--pad-right" (click)="previousStep()" [disabled]="stepper.selectedIndex === 0 || disabled">
    Previous
  </button>
  @if (stepper.selectedIndex !== stepper.steps.length - 1 || stepper.selectedIndex === 0 || !options.showSubmitButtonOnLastStep) {
    <button
      mat-raised-button
      (click)="nextStep()"
      [disabled]="stepper.selectedIndex === stepper.steps.length - 1 || disabled"
      [@pulseNext]="pulseNext ? 'updating' : 'normal'"
      class="wizard-buttons__next"
    >
      Next
    </button>
  }
  @if (stepper.selectedIndex === stepper.steps.length - 1 && stepper.selectedIndex !== 0 && options.showSubmitButtonOnLastStep) {
    <button mat-raised-button class="button--accent" (click)="submit()" [disabled]="disabled">{{ options.submitButtonText }}</button>
  }
</div>
